module.exports = __webpack_public_path__ + "img/user-ninja.124e3815.svg";